/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionalertpurchaseunavailabletitle4Inputs */



/**
* | output |
* | --- |
* | "Payment unavailable" |
*
* @param {Subscriptionalertpurchaseunavailabletitle4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscriptionalertpurchaseunavailabletitle4 = /** @type {((inputs?: Subscriptionalertpurchaseunavailabletitle4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionalertpurchaseunavailabletitle4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Payment unavailable")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pago no disponible")
	return /** @type {LocalizedString} */ ("Оплата недоступна")
});
export { subscriptionalertpurchaseunavailabletitle4 as "subscriptionAlertPurchaseUnavailableTitle" }